export var Reason;
(function (Reason) {
    Reason[Reason["CONTENT_NOT_AVAILABLE"] = 0] = "CONTENT_NOT_AVAILABLE";
    Reason[Reason["CONTENT_NOT_AVAILABLE_IN_LOCATION"] = 1] = "CONTENT_NOT_AVAILABLE_IN_LOCATION";
    Reason[Reason["CONTENT_NOT_FOUND"] = 2] = "CONTENT_NOT_FOUND";
})(Reason || (Reason = {}));
